import React, { FunctionComponent } from 'react';
import { Toggle } from '../GlobalUI';

interface Props {
  isEnabled: boolean;
  onToggle: (property: string, val: string) => void;
  property: string;
}

export const TestDriveEnabled: FunctionComponent<Props> = ({
  isEnabled,
  onToggle,
  property,
}) => (
  <div className="input-container input-toggle-switch-container">
    <div className="input-container widget-text-toggle-group">
      <label>
        Remote Test Drive Enabled
        <Toggle
          value={isEnabled}
          onToggle={(value: string) => {
            onToggle(property, value);
          }}
        />
      </label>
    </div>
  </div>
);
